import { memo } from "react";
import { JobLevelBackfillPromptHost } from "./job-level-backfill/job-level-backfill-prompt-host";
import { ReclaimInstallAppPromptHost } from "./reclaim-install-app-modal/reclaim-install-app-prompt-host";

export const MerchantPromptHost = memo(function MerchantPromptHost() {
  return (
    <>
      <ReclaimInstallAppPromptHost />
      <JobLevelBackfillPromptHost />
    </>
  );
});
